import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './scss/main.scss'   // 加这行
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import request from '@/utils/request'

Vue.prototype.$request = request
Vue.prototype.$get = request.get
Vue.prototype.$post = request.post
Vue.prototype.$put = request.put
Vue.prototype.$del = request.delete

Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
